/* Native Shopify contact form; success comes only from the server-rendered Liquid form result. */
(() => {
  'use strict';
  if (window.__m24FreightQuote) return;
  window.__m24FreightQuote = true;
  const instances = new WeakMap();
  const PHONE_ERROR = 'Introdu un număr valid, de exemplu 0753 502 680 sau +40 753 502 680.';

  function normalizePhone(value) {
    if (!/^[+\d\s().-]+$/.test(value)) return null;
    let phone = value.replace(/[\s().-]/g, '').replace(/^00/, '+');
    if (/^0[237]\d{8}$/.test(phone)) phone = '+40' + phone.slice(1);
    if (!/^\+[1-9]\d{7,14}$/.test(phone)) return null;
    if (phone.startsWith('+40') && !/^\+40[237]\d{8}$/.test(phone)) return null;
    if (/^(\d)\1+$/.test(phone.slice(1))) return null;
    return phone;
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-m24-quote-root]').forEach(root => {
      if (instances.has(root)) return;
      const dialog = root.querySelector('[data-m24-quote-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const events = new AbortController();
      const options = { signal: events.signal };
      const form = root.querySelector('form.m24-freight-quote-form');
      const opener = root.querySelector('[data-m24-quote-open]');
      const close = root.querySelector('[data-m24-quote-close]');
      const fields = root.querySelector('[data-m24-quote-fields]');
      const status = root.querySelector('[data-m24-quote-status]');
      const phoneError = root.querySelector('[data-m24-quote-phone-error]');
      const button = form.querySelector('[type=submit]');
      const inputs = ['contact[name]', 'contact[phone]', 'contact[body]', 'contact[email]'].map(name => form.elements.namedItem(name));
      let succeeded = false;
      let outsidePointer = false;

      function viewport() {
        if (!dialog.open) return;
        dialog.style.setProperty('--m24-quote-height', (window.visualViewport?.height || innerHeight) + 'px');
        dialog.style.setProperty('--m24-quote-offset', (window.visualViewport?.offsetTop || 0) + 'px');
      }
      function closed() {
        document.body.classList.remove('m24-freight-quote-open');
        opener.focus({ preventScroll: true });
      }
      function validate(input, display = false) {
        const value = input.value.trim();
        const invalidPhone = input.name === 'contact[phone]' && value && !normalizePhone(value);
        const error = invalidPhone ? PHONE_ERROR : !value ? 'Completează acest câmp.' : '';
        input.setCustomValidity(error);
        if (display) input.setAttribute('aria-invalid', error ? 'true' : 'false');
        else if (!error) input.removeAttribute('aria-invalid');
        if (input.name === 'contact[phone]') phoneError.hidden = !(display && invalidPhone);
        return !error;
      }
      opener.addEventListener('click', () => {
        if (dialog.open) return;
        if (succeeded) {
          succeeded = false;
          fields.hidden = false;
          status.hidden = true;
          form.reset();
          inputs.forEach(input => { input.setCustomValidity(''); input.removeAttribute('aria-invalid'); });
          phoneError.hidden = true;
        }
        dialog.showModal();
        document.body.classList.add('m24-freight-quote-open');
        viewport();
        close.focus({ preventScroll: true });
      }, options);
      close.addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('close', closed, options);
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('button:not([disabled]),input:not([disabled]),textarea:not([disabled]),a[href]')].filter(node => node.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);
      function isOutside(event) {
        const box = dialog.getBoundingClientRect();
        return event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
      }
      dialog.addEventListener('pointerdown', event => { outsidePointer = isOutside(event); }, options);
      dialog.addEventListener('click', event => { if (outsidePointer && isOutside(event)) dialog.close(); outsidePointer = false; }, options);
      window.addEventListener('resize', viewport, options);
      window.visualViewport?.addEventListener('resize', viewport, options);
      window.visualViewport?.addEventListener('scroll', viewport, options);
      inputs.forEach(input => {
        input.addEventListener('input', () => validate(input, input.getAttribute('aria-invalid') === 'true'), options);
        input.addEventListener('blur', () => { if (input.value) validate(input, true); }, options);
        input.addEventListener('invalid', () => validate(input, true), options);
      });

      form.addEventListener('submit', event => {
        const valid = inputs.map(input => validate(input, true)).every(Boolean);
        if (!valid || !form.reportValidity()) {
          event.preventDefault();
          form.reportValidity();
        }
        // Valid requests proceed through Shopify's native form and spam protection.
      }, options);
      opener.hidden = false;
      const result = root.querySelector('[data-m24-quote-result]');
      if (result) {
        dialog.showModal();
        document.body.classList.add('m24-freight-quote-open');
        viewport();
        result.focus({ preventScroll: true });
      }

      instances.set(root, () => {
        if (dialog.open) { dialog.close(); document.body.classList.remove('m24-freight-quote-open'); }
        events.abort();
        instances.delete(root);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-m24-quote-root]').forEach(root => instances.get(root)?.()));
})();
